import Right from '@/assets/right.png';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import TopTitle from '@/components/TopTitle.vue';
export default {
  name: 'CollectHome',
  components: {
    TopTitle
  },

  setup() {
    const router = useRouter();
    const info = computed(() => {
      return store.getters.invInfo;
    });

    const back = () => {
      const param = {
        method: 'closeWindow',
        params: {
          url: info.value.url
        },
        callback: ''
      };

      if (window.HybridAPI !== undefined) {
        window.HybridAPI.sendToNative(JSON.stringify(param)); // eslint-disable-next-line no-undef
      } else if (FlutterBridge !== undefined) {
        // eslint-disable-next-line no-undef
        FlutterBridge.postMessage(JSON.stringify(param)); // eslint-disable-next-line no-undef
      } else if (hmObject !== undefined) {
        // eslint-disable-next-line no-undef
        hmObject.close();
      } else {
        router.back();
        window.close();
      }
    };

    return {
      Right,
      back,
      router,
      info
    };
  }

};